import React, { useState } from 'react';
import * as Styles from './AccountSecurity.styles';
import { useSelector } from 'react-redux';
import { TwoFactorAuth } from './TwoFactorAuth';
import useLocale from '@/hooks/useLocale';
import ChangePassword from './ChangePassword';
import ChangePasswordModal from './ChangePassword/ChangePasswordModal';
import { handleCoverPhoneNumber } from '@/utils/handlers/handleCoverPhoneNumber';
import { handleCoverEmail } from '@/utils/handlers/handleCoverEmail';
import { ValidationCodeFlow } from './TwoFactorAuth/ValidationCodeFlow';

const AccountSecurity = () => {
  const { email, phoneNumber, phoneNumberCountry } = useSelector(state => state.summary);
  const { myData: myDataLocale } = useLocale();
  const twoFactorIsEnabled = useSelector(state => state.summary.twoFactorIsEnabled);
  const twoFactorAuthLocale = myDataLocale.twoFactorAuth;
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showChooseMethodModal, setShowChooseMethodModal] = useState(false);
  const [currentStep, setCurrentStep] = useState('CHOOSE_METHOD');

  const [validateCodeModal, setModalVaidateCodeModal] = useState({
    open: false,
    title: '',
    primaryButtonLabel: '',
    type: '',
    method: '',
  });

  const userPhone = handleCoverPhoneNumber({ phoneNumber, phoneNumberCountry });
  const userEmail = handleCoverEmail(email);


  const togglePasswordModal = () => {
    setShowChangePasswordModal(prev => !prev);
  };

  const toggleValidationCodeFlow = () => {
    setShowChooseMethodModal(prev => !prev);
    setCurrentStep('CHOOSE_METHOD');
  };

  const openDisableTwoFactorModal = (selectedMethod) => {
    setCurrentStep('VALIDATE_CODE');
    setModalVaidateCodeModal({
      open: true,
      title: twoFactorAuthLocale.validateCodeModal.disable2FA.title,
      primaryButtonLabel: twoFactorAuthLocale.validateCodeModal.disable2FA.buttonLabel,
      type: 'disable',
      method: selectedMethod,
    });
  };

  const openEnableTwoFactorModal = (selectedMethod) => {
    setCurrentStep('VALIDATE_CODE');
    setModalVaidateCodeModal({
      open: true,
      title: twoFactorAuthLocale.validateCodeModal.enable2FA.title,
      primaryButtonLabel: twoFactorAuthLocale.validateCodeModal.enable2FA.buttonLabel,
      type: 'enable',
      method: selectedMethod,
    });
  };

  const goToValidateStep = twoFactorIsEnabled ? openDisableTwoFactorModal : openEnableTwoFactorModal;
  const goToChooseMethodStep = () => setCurrentStep('CHOOSE_METHOD');

  return (
    <>
      <Styles.Wrapper>
        <Styles.Container>
          <Styles.Content>
            <ChangePassword
              togglePasswordModal={togglePasswordModal}
            />
            <Styles.Divider />
            <TwoFactorAuth
              userEmail={userEmail}
              twoFactorIsEnabled={twoFactorIsEnabled}
              twoFactorAuthLocale={twoFactorAuthLocale}
              twoAuthButtonClick={toggleValidationCodeFlow}
            />
          </Styles.Content>
        </Styles.Container>
      </Styles.Wrapper>

      <ValidationCodeFlow
        showChooseMethodModal={showChooseMethodModal}
        goToValidateStep={goToValidateStep}
        goToChooseMethodStep={goToChooseMethodStep}
        currentStep={currentStep}
        twoFactorIsEnabled={twoFactorIsEnabled}
        toggleValidationCodeFlow={toggleValidationCodeFlow}
        validateCodeModal={validateCodeModal}
        twoFactorAuthLocale={twoFactorAuthLocale}
        userEmail={userEmail}
        userPhone={userPhone}
      />

      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        togglePasswordModal={togglePasswordModal}
      />
    </>
  );
};

export default AccountSecurity;
